import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { catchError, merge, of, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { PageTitleRequestService } from '../../services/router/requests/router-request.service';
import { PageTitleService } from '../../services/router/title.service';
import { SearchProgressService } from '../../services/search-progress.service';

@Component({
  selector: 'page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PageTitleComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isLoading = true;  // состояние загрузки
  hasError = false;  // состояние ошибки
  errorMessage = '';  // сообщение об ошибке
  navBarTitleData: any = null; // данные для титула

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private searchProgressService: SearchProgressService,
    private routerRequestService: PageTitleRequestService,
    private pageTitleService: PageTitleService
  ) {}

  ngOnInit(): void {
    // Подписка на события маршрутизации
    merge(
      this.router.events.pipe(
        filter(e => e instanceof NavigationStart),
        tap((e) => this.handleLoadingTitle(e as NavigationStart))
      ),
      this.router.events.pipe(
        filter(e => e instanceof NavigationEnd),
        tap(() => this.handleFinalTitle()) // Запрос титула после завершения навигации
      )
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Метод для запроса данных титула
  private request() {
    // Получаем параметры из URL
    const params = {
      ...this.route.snapshot.params,
      ...this.route.snapshot.queryParams
    };

    const fromRoute = this.router.url.split('?')[0];
    const requestParams = { ...params, fromRoute };

    // Выполняем запрос с параметрами
    this.routerRequestService.getNavBarTitleData(requestParams).subscribe(
      (data) => {
        if (data?.success === true) {
          this.navBarTitleData = data;
          this.pageTitleService.setTitle(data.type, data);
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Ошибка при запросе данных для NavBar:', error);
        this.hasError = true;
        this.errorMessage = 'Ошибка при загрузке данных';
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // Обработка титула после завершения навигации
  private handleFinalTitle() {
    this.request();
  }

  // Обработка титула во время начала навигации
  private handleLoadingTitle(e: NavigationStart) {
    this.pageTitleService.beforeRequestTitle(e);
  }

  // Функция для получения самого глубокого дочернего маршрута
  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
